import React, { useState } from "react";
import {
  Box,
  Text,
  Button,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  CloseButton,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

// Define a mapping for notification types to Chakra UI Alert statuses
const STATUS_MAP = {
  warning: "warning",
  success: "success",
  error: "error",
  info: "info",
};

const AlertNotification = ({ id, title, message, alertStatus, type, action, onMarkAsRead, onDismiss }) => {
  const [visible, setVisible] = useState(true);
  const status = STATUS_MAP[alertStatus] || "info"; // Fallback to "info" if type is unknown

  const handleDismiss = async () => {
    setVisible(false); // Hide the alert
    if (onDismiss) await onDismiss(id);
  };

  if (!visible) return null; // If dismissed, do not render

  return (
    <Alert status={status} variant="left-accent" borderRadius="md" mb={4}>
      <AlertIcon />
      <Box flex="1">
        <AlertTitle fontSize="lg">{title}</AlertTitle>
        <AlertDescription fontSize="md">{message}</AlertDescription>
      </Box>
      {action?.url && action?.label && (
        <Button
          as={RouterLink}
          to={action.url}
          colorScheme="blue"
          size="sm"
          mx={8}
          onClick={() => {
            if (onMarkAsRead) onMarkAsRead(id);
            handleDismiss();
          }}
        >
          {action.label}
        </Button>
      )}
      <CloseButton position="absolute" right="8px" top="8px" onClick={handleDismiss} />
    </Alert>
  );
};

export default AlertNotification;
